import type { MergeDiffResult } from 'flow/service/changelog/formatters/mergeDropdownFormatter/types';
import type { PublicId } from 'flow/store/engine/types';
import { selectMovedThresholds, selectWorkflowDiff } from 'flow/store/redux/selectors';
import type { ReactNode } from 'react';
import { createContext } from 'react';
import { useSelector } from 'react-redux';

export const panes = {
  left: 'left',
  right: 'right',
} as const;

export type Pane = keyof typeof panes;

export const DiffContext = createContext<MergeDiffResult>({
  added: new Set<PublicId>(),
  modified: new Set<PublicId>(),
  removed: new Set<PublicId>(),
});

function DiffContextProvider({ children, pane }: { children: ReactNode; pane: Pane }) {
  const workflowDiff = useSelector(selectWorkflowDiff);
  const movedThresholds = useSelector(selectMovedThresholds);

  const createPanedDiff = () => {
    if (pane === 'left') {
      return {
        added: workflowDiff.added,
        modified: workflowDiff.modified,
        removed: new Set<PublicId>([...workflowDiff.removed, ...movedThresholds]),
      };
    }

    return {
      added: new Set<PublicId>([...workflowDiff.added, ...movedThresholds]),
      modified: workflowDiff.modified,
      removed: workflowDiff.removed,
    };
  };

  const panedDiff = createPanedDiff();

  return (
    <DiffContext.Provider value={panedDiff}>
      {children}
    </DiffContext.Provider>
  );
}

export default DiffContextProvider;
